import { Box, Typography } from "@mui/material";
import { YEAR } from "./constants/festivalDates";

const Footer = () => {
  return (
    <Box
      sx={{
        height: "200px",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        marginBottom: "60px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          textTransform: "uppercase",
          color: "teal.main",
        }}
      >
        © Amplitude Festival {YEAR}
      </Typography>
    </Box>
  );
};

export default Footer;
